import {Component} from '@angular/core';
import {ContainerComponent} from '../../container/container.component';
import {SearchBarComponent} from '../search-bar/search-bar.component';
import {HeaderService} from '../../../shared/header.service';
import {BehaviorSubject, map, Observable} from 'rxjs';
import {AsyncPipe, NgClass, NgOptimizedImage} from '@angular/common';
import {HeaderVariant} from '../../../enums/header-variant';
import {RouterLink, RouterLinkActive} from '@angular/router';
import {NgIcon, provideIcons} from '@ng-icons/core';
import {heroCalendarDays, heroCog6Tooth, heroListBullet, heroMap, heroBars3} from '@ng-icons/heroicons/outline';
import {heroMapPinSolid} from '@ng-icons/heroicons/solid';
import {tablerRoute} from '@ng-icons/tabler-icons';
import {MenuComponent} from '../menu/menu.component';
import {Dialog} from '@angular/cdk/dialog';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [ContainerComponent, SearchBarComponent, AsyncPipe, NgClass, NgOptimizedImage, RouterLink, NgIcon, RouterLinkActive],
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  viewProviders: [provideIcons({heroMap, heroCalendarDays, heroListBullet, heroCog6Tooth, heroMapPinSolid, tablerRoute, heroBars3})]
})
export class HeaderComponent {
  protected title: BehaviorSubject<string | null>;
  protected variant: BehaviorSubject<HeaderVariant>;
  protected readonly headerVariant = HeaderVariant;
  protected heightClass$: Observable<string>;

  constructor(private _headerService: HeaderService, private _dialog: Dialog) {
    this.title = this._headerService.title$;
    this.variant = this._headerService.variant$;
    this.heightClass$ = this.variant.pipe(
      map(variant => variant === HeaderVariant.SMALL ? 'lg:h-header lg:rounded-b-header' : 'h-header rounded-b-header')
    );
  }

  protected openMenu() {
    this._dialog.open(MenuComponent, {
      panelClass: 'menu-dialog-panel',
      backdropClass: 'menu-dialog-backdrop',
      disableClose: true,
    });
  }
}
